<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BaseSplitBtn',
  mixins: [baseMixin],
  inheritAttrs: false,
  props: {
    dense: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      buttonModel: null,
    }
  },
}
</script>

<template>
  <v-item-group :class="['v-btn-toggle', dense ? 'v-btn-toggle--dense' : '']">
    <v-btn v-bind="$attrs" v-on="$listeners"><slot /></v-btn>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="{ ...attrs, ...$attrs }" v-on="on"
          ><v-icon>mdi-chevron-down</v-icon></v-btn
        >
      </template>
      <slot name="menu">
        <v-list dense>
          <v-list-item>
            <v-list-item-title>Item 1</v-list-item-title>
          </v-list-item>
        </v-list>
      </slot>
    </v-menu>
  </v-item-group>
</template>
